import * as React from 'react';
import '../../sass/StoryEditComponent.css';
import AppUtils from '../../utils/AppUtils';
import { Fade, Glyphicon, Button, DropdownButton, MenuItem } from 'react-bootstrap';
import PageEditComponent from './PageEditComponent';
import { db } from '../../firebase/firebase';
import NewPageInputComponent from './NewPageInputComponent';
import ChapterTitleComponent from './ChapterTitleComponent';
import Tag from 'src/objects/Tag';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import moveItem from 'array-move-item';
import Decision from 'src/objects/Decision';

// import FeatureStatComponent from './dashboardComponents/FeatureStatComponent';

const SortableItem = SortableElement<any>(({index, shouldSave, value, storyState, storyProps, pageElementRef, closeCurrentOpenPage}) => 
    <PageEditComponent
        index={index}
        shouldSave={shouldSave}
        ref={pageElementRef}
        closeCurrentOpenPage={closeCurrentOpenPage}
        id={value.id.toString()}
        key={value.id.toString()}
        canDelete={value.canDelete}
        addNewPage={storyProps.addNewPage}
        currentDecisionId={value.currentDecisionId}
        currentChapter={storyProps.currentChapter}
        chapters={storyProps.chapters}
        story={storyProps.chapters[storyProps.currentChapter].storys[index]}
        recommendedTags={storyState.recommendedTags}
        decisions={storyProps.chapters[storyProps.currentChapter].storys[index].decisions}
        pageText={storyProps.chapters[storyProps.currentChapter].storys[index].text}
        pageTextDecoded={storyProps.chapters[storyProps.currentChapter].storys[index].textDecoded}
        onStoryUpdated={storyProps.onStoryUpdated}
        onChapterUpdated={storyProps.onChapterUpdated}
        headerHidden={false}
        bodyHidden={true}
        storyPanelSelectedStoryID={storyState.storyPanelSelectedStoryID}
        storyPanelSelected={this.pageSelected}
    />
);

export const SortableList = SortableContainer<any>(({items, shouldSave, pageElementRef, storyProps, storyState, onPressSaveChapter}) => {
    return (
        <ul className="pages">
            {items.map((value:any, index:any) => 
            {
                return storyProps.chapters[storyProps.currentChapter].storys[index].locked ?
                null : <SortableItem key={`item-${value.id}`} shouldSave={shouldSave} pageElementRef={pageElementRef} onPressSaveChapter={onPressSaveChapter} index={index} storyProps={storyProps} storyState={storyState} value={value} />
            }
            )}
        </ul>
    );
  });

export default class StoryEditComponent extends React.Component<any, any> {
    
    private tagsRef:firebase.database.Reference = db.app.database().ref('settings').child('tags')
    private chapterTitleComponentRef: React.RefObject<any>;
    private currentOpenPage: PageEditComponent;
    private pageElementRef: React.RefObject<any>;

    constructor(props:any) {
        super(props);

        this.pageElementRef = React.createRef();

        this.state = {
            visible: false,
            shouldSave: false,
            addPageInput: "",
            editingChapterName: false,
            recommendedTags: [],
        }

        this.chapterTitleComponentRef = React.createRef();

        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.onTagsUpdated = this.onTagsUpdated.bind(this);

        // this.addNewPageInputRef = React.createRef();

        this.onPressSaveChapter = this.onPressSaveChapter.bind(this);
        this.addNewPage = this.addNewPage.bind(this);
        this.canDeleteChapter = this.canDeleteChapter.bind(this);
        this.onChapterNameUpdated = this.onChapterNameUpdated.bind(this);
    }

    componentDidMount() {
        this.tagsRef.on('value', this.onTagsUpdated);
    }

    private onTagsUpdated(snapshot:any):void {
        let recommendedTags:Array<Tag> = []
        snapshot.forEach(function(item) {
            recommendedTags.push(item.val());
        });
        // console.log(recommendedTags)
        this.setState({recommendedTags: recommendedTags})
    }

    private canShow():boolean {
        if (!AppUtils.isMobile && this.props.isVisible) {
            return true;
        }
        return false;
    }

    private addNewPage(pageText:string, decisions?:Array<Decision>, position?:number):any {
        // e.preventDefault();
        this.props.addNewPage(pageText, decisions, position)
        // console.log("Adding new page: ", this.state.addPageInput)
    }

    // private getPages():any {
    //     return this.props.chapters[0].storys;
    //   }

    private show() {
        this.setState({visible: true})
      }
  
    private hide() {
        this.setState({visible: false})
    }

    private pageSelected() {
        console.log("page selected");
    }

    // private pageUpdated() {
    //     // console.log("page updated");
    //     this.props.onStoryUpdated()
    // }

    // private onPageInputChange(event) {
    //     this.setState({addPageInput: event.target.value});
    // }

    // shouldComponentUpdate(nextProps, nextState) {
    //     return this.props.chapters != nextProps.chapters; 
    // }

    private canDeleteChapter():boolean {
        return true;
    }

    componentDidUpdate(prevProps, prevState) {
        // only update chart if the data has changed
        if (this.state.shouldSave) {
            this.setState({shouldSave: false});
        }
        if (this.chapterTitleComponentRef.current.getChapterName() !== this.props.chapters[this.props.currentChapter].name) {
            this.chapterTitleComponentRef.current.setChapterName(this.props.chapters[this.props.currentChapter].name);
        }
    }

    private saveChapterName():void {
        let chapterName:string = this.chapterTitleComponentRef.current.getChapterName();
        this.onChapterNameUpdated(chapterName);
        this.setState({editingChapterName: false});
    }

    private editChapterName():void {
        this.setState({editingChapterName: true})
        this.chapterTitleComponentRef.current.focus();
    }

    private handleChangeChapter(eventKey: any, e: any):void {
        let newChapterIndex = AppUtils.findIndexByKey(this.props.chapters, "id", parseInt(e.target.id))
        this.props.onChapterChange(newChapterIndex);
        this.chapterTitleComponentRef.current.setChapterName(e.target.text);
    }

    private onChapterNameUpdated(chapterName:string):void {
        this.props.analyticsDatabaseRef.child(this.props.chapters[this.props.currentChapter].id).child("name").set(chapterName);
        let chapters = this.props.chapters;
        chapters[this.props.currentChapter].name = chapterName;
        this.props.onChapterUpdated(chapters);
    }

    private addNewChapter(e?:any) {
        this.props.addNewChapter()
    }

    private onPressSaveChapter(e?:any) {
        // console.log(this.pageElementRef.current);
        this.setState({shouldSave: true})
    }

    private onPressDeleteChapter(e?:any) {
        // console.log("deleting chapter: ", this.props.currentChapter)
        // console.log("C: ", this.props.chapters[this.props.currentChapter]);
        this.props.analyticsDatabaseRef.child(this.props.chapters[this.props.currentChapter].id).remove();
        let chapters:Array<any> = this.props.chapters;
        chapters.splice(this.props.currentChapter, 1);
        this.props.onChapterChange(0);
        this.props.onChapterUpdated(chapters);
        // this.props.onStoryUpdated(storys, true, true);
    }

    onSortEnd = ({oldIndex, newIndex}) => {
        let chapters = this.props.chapters;
        chapters[this.props.currentChapter].storys = moveItem(chapters[this.props.currentChapter].storys, oldIndex, newIndex);
        this.props.onChapterUpdated(chapters);
    };

    render() {
        return (
        <Fade in={this.canShow()} onExited={this.hide} onEntering={this.show}>
            <div id="storyEditContainer" className="pageContainer" style={{visibility: this.props.isVisible ? 'visible' : 'hidden'}}>
                <div id="header">
                    
                    <h2 className="pageHeader">
                    <ChapterTitleComponent ref={this.chapterTitleComponentRef} onChapterNameUpdated={this.onChapterNameUpdated} currentChapterName={this.props.chapters[this.props.currentChapter].name} />
                    </h2>
                    <div id="chapterButtons">
                        <DropdownButton
                            className="dropdownBtn chapterSelectionDropdown"
                            bsStyle={"default"}
                            title={this.props.chapters[this.props.currentChapter].name}
                            key={"btnKey1"}
                            id="input-dropdown-addon"
                            >
                            <MenuItem key="AddNewChapter" eventKey="AddNewChapter" onSelect={this.addNewChapter.bind(this)}>Add New Chapter</MenuItem>
                            <MenuItem divider />
                            <MenuItem header>Chapters</MenuItem>
                            {this.props.chapters.map((c:any, i:number) => <MenuItem id={c.id} key={c.id} title={this.props.chapters[i].name} onSelect={this.handleChangeChapter.bind(this)}>{this.props.chapters[i].name}</MenuItem>)}
                        </DropdownButton>
                        <Button className="editChapterBtn highlightOnHover" bsStyle="default" onClick={this.state.editingChapterName? this.saveChapterName.bind(this) : this.editChapterName.bind(this)}>
                            <Glyphicon glyph={this.state.editingChapterName? "ok" : "pencil"} />
                        </Button>
                        <Button className="editChapterBtn highlightOnHover" bsStyle="default" onClick={() => this.onPressSaveChapter()}>
                            <Glyphicon glyph="floppy-disk" />
                        </Button>
                        {
                            this.canDeleteChapter() ?
                            <Button className="editChapterBtn highlightOnHover" bsStyle="default" onClick={() => this.onPressDeleteChapter()}>
                                <Glyphicon glyph="trash" />
                            </Button> : null
                        }
                    </div>
                </div>
                <NewPageInputComponent addNewPage={this.addNewPage} />
                {this.props.chapters[this.props.currentChapter].storys.map((value:any, index:any) => 
                {
                    return this.props.chapters[this.props.currentChapter].storys[index].locked ?
                    <PageEditComponent
                        index={index}
                        shouldSave={this.state.shouldSave}
                        ref={this.pageElementRef}
                        closeCurrentOpenPage={this.onPressSaveChapter}
                        id={value.id.toString()}
                        key={value.id.toString()}
                        canDelete={value.canDelete}
                        addNewPage={this.props.addNewPage}
                        currentDecisionId={value.currentDecisionId}
                        currentChapter={this.props.currentChapter}
                        chapters={this.props.chapters}
                        story={this.props.chapters[this.props.currentChapter].storys[index]}
                        recommendedTags={this.state.recommendedTags}
                        decisions={this.props.chapters[this.props.currentChapter].storys[index].decisions}
                        pageText={this.props.chapters[this.props.currentChapter].storys[index].text}
                        pageTextDecoded={this.props.chapters[this.props.currentChapter].storys[index].textDecoded}
                        onStoryUpdated={this.props.onStoryUpdated}
                        onChapterUpdated={this.props.onChapterUpdated}
                        headerHidden={false}
                        bodyHidden={true}
                        storyPanelSelectedStoryID={this.state.storyPanelSelectedStoryID}
                        storyPanelSelected={this.pageSelected}
                    /> : null
                }
                )}
                <SortableList shouldSave={this.state.shouldSave} pageElementRef={this.pageElementRef} onPressSaveChapter={this.onPressSaveChapter} useDragHandle={true} items={this.props.chapters[this.props.currentChapter].storys} storyProps={this.props} storyState={this.state} onSortEnd={this.onSortEnd}/>
            </div>
        </Fade>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/storyEditComponent/StoryEditComponent.tsx